export const projectReportsData = [
  {
    name: "Truelysell",
    client: "NovaWave LLC",
    priority: "High",
    startDate: "2023-09-25",
    endDate: "2023-10-15",
    type: "Web App",
    pipelineStage: "Plan",
    budgetValue: "$200000",
    currentlySpend: "$40000",
    companyLogo: "assets/img/icons/company-icon-01.svg",
    priorityImg: "assets/img/priority/truellysel.svg",
    key: "1"
  },
  {
    name: "Dreamschat",
    client: "BlueSky Industries",
    priority: "Medium",
    startDate: "2023-09-29",
    endDate: "2023-10-19",
    type: "Web App",
    pipelineStage: "Develop",
    budgetValue: "$300000",
    currentlySpend: "$120000",
    companyLogo: "assets/img/icons/company-icon-02.svg",
    priorityImg: "assets/img/priority/truellysell.svg",
    key: "2"
  },
  {
    name: "Truelysell",
    client: "SilverHawk",
    priority: "High",
    startDate: "2023-10-05",
    endDate: "2023-10-12",
    type: "Web App",
    pipelineStage: "Completed",
    budgetValue: "$200000",
    currentlySpend: "$200000",
    companyLogo: "assets/img/icons/company-icon-03.svg",
    priorityImg: "assets/img/priority/best.svg",
    key: "3"
  },
  {
    name: "Servbook",
    client: "SummitPeak",
    priority: "Medium",
    startDate: "2023-10-14",
    endDate: "2023-10-24",
    type: "Web App",
    pipelineStage: "Design",
    budgetValue: "$300000",
    currentlySpend: "$60000",
    companyLogo: "assets/img/icons/company-icon-04.svg",
    priorityImg: "assets/img/priority/servbook.svg",
    key: "4"
  },
  {
    name: "DreamPOS",
    client: "RiverStone Ventur",
    priority: "Low",
    startDate: "2023-11-15",
    endDate: "2023-11-22",
    type: "Web App",
    pipelineStage: "Design",
    budgetValue: "$120000",
    currentlySpend: "$40000",
    companyLogo: "assets/img/icons/company-icon-05.svg",
    priorityImg: "assets/img/priority/dream-pos.svg",
    key: "5"
  },
  {
    name: "Kofejob",
    client: "CoastalStar Co.",
    priority: "High",
    startDate: "2023-11-25",
    endDate: "2023-12-09",
    type: "Meeting",
    pipelineStage: "Develop",
    budgetValue: "$200000",
    currentlySpend: "$90000",
    companyLogo: "assets/img/icons/company-icon-06.svg",
    priorityImg: "assets/img/priority/project-01.svg",
    key: "6"
  },
  {
    name: "Doccure",
    client: "HarborView",
    priority: "Medium",
    startDate: "2023-12-08",
    endDate: "2023-12-16",
    type: "Web App",
    pipelineStage: "Completed",
    budgetValue: "$200000",
    currentlySpend: "$195000",
    companyLogo: "assets/img/icons/company-icon-07.svg",
    priorityImg: "assets/img/priority/dreamchat.svg",
    key: "7"
  },
  {
    name: "Best@laundry",
    client: "Golden Gate Ltd",
    priority: "Low",
    startDate: "2023-12-21",
    endDate: "2024-01-13",
    type: "Meeting",
    pipelineStage: "Completed",
    budgetValue: "$230000",
    currentlySpend: "$220000",
    companyLogo: "assets/img/icons/company-icon-08.svg",
    priorityImg: "assets/img/priority/dream-pos.svg",
    key: "8"
  },
  {
    name: "POS",
    client: "CoastalStar Inc",
    priority: "Medium",
    startDate: "2024-01-01",
    endDate: "2024-01-11",
    type: "Web App",
    pipelineStage: "Develop",
    budgetValue: "$200000",
    currentlySpend: "$177777",
    companyLogo: "assets/img/icons/company-icon-09.svg",
    priorityImg: "assets/img/priority/sports.svg",
    key: "9"
  },
  {
    name: "Bookserv",
    client: "Redwood Inc",
    priority: "Medium",
    startDate: "2024-01-12",
    endDate: "2024-01-29",
    type: "Meeting",
    pipelineStage: "Develop",
    budgetValue: "$300000",
    currentlySpend: "$100000",
    companyLogo: "assets/img/icons/company-icon-10.svg",
    priorityImg: "assets/img/priority/project-02.svg",
    key: "10"
  },
];
